import React from 'react';
import OntologySearchPanel from './OntologySearchPanel';
import '../style/index.css';
import LogicFlow from '@logicflow/core';

interface TopLeftPanelProps {
  onSaveViewState?: () => void;
  onRestoreViewState?: () => void;
  onResetView?: () => void;
}

const TopLeftPanel: React.FC<TopLeftPanelProps> = ({
  onSaveViewState,
  onRestoreViewState,
  onResetView
}) => {
  return (
    <div className="top-left-panel">
      <div className="top-left-panel-content">
        <OntologySearchPanel
          onSaveViewState={onSaveViewState}
          onRestoreViewState={onRestoreViewState}
          onResetView={onResetView}
        />
      </div>
    </div>
  );
};

export default TopLeftPanel;